import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";

const TabContainer = styled.div`
  display: flex;
  position: relative;
  background-color: var(--surface3);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 4px;
  width: 90%;
  /* width: fit-content; */
`;

const Tab = styled.button`
  padding: 10px 10px;
  border: none;
  background: transparent;
  font-size: 12px;
  font-weight: 700;
  border-radius: 999px;
  cursor: pointer;
  z-index: 1;
  flex: 1;
  color: ${({ active }) => (active ? "var(--accentAlt)" : "var(--elementDim)")};
  transition: color 0.2s ease;
`;

const Pill = styled.div`
  position: absolute;
  top: 4px;
  left: ${({ left }) => `${left}px`};
  width: ${({ width }) => `${width}px`};
  height: calc(100% - 8px);
  background: var(--accent);
  border-radius: 10px;
  transition: all 0.3s ease;
  z-index: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const AnimatedPillTabsForTheme = ({
  tabs = [],
  activeIndex,
  setActiveIndex,
  accentAltColor = "var(--accentAlt)",
  surfaceColor = "var(--surface)",
  elementColor = "var(--element)",
  accentColor = "var(--accent)",
}) => {
  const [pillStyle, setPillStyle] = useState({ left: 0, width: 0 });
  const tabRefs = useRef([]);

  useEffect(() => {
    const currentTab = tabRefs.current[activeIndex];
    if (currentTab) {
      setPillStyle({
        left: currentTab.offsetLeft,
        width: currentTab.offsetWidth,
      });
    }
  }, [activeIndex, tabs]);

  const handleTabClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <TabContainer>
      <Pill
        style={{ background: accentColor }}
        left={pillStyle.left}
        width={pillStyle.width}
      />
      {tabs.map((item, index) => (
        <Tab
          style={{
            color: index === activeIndex ? accentAltColor : elementColor,
          }}
          key={item.label}
          active={index === activeIndex}
          onClick={() => handleTabClick(index)}
          ref={(el) => (tabRefs.current[index] = el)}
        >
          {item.label}
        </Tab>
      ))}
    </TabContainer>
  );
};

export default AnimatedPillTabsForTheme;
